module.exports = __webpack_public_path__ + "media/images/baseCodelco-91407b9b56c4fc43d641312d99bd1107.png";